export default "__VITE_ASSET__9a1ce2ce__"